import { render, staticRenderFns } from "./DashboardGerente.vue?vue&type=template&id=4ceaac01&scoped=true&"
import script from "./DashboardGerente.vue?vue&type=script&lang=js&"
export * from "./DashboardGerente.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGerente.vue?vue&type=style&index=0&id=4ceaac01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceaac01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow})
